import React from "react";
import { FormattedDate, FormattedTime } from "react-intl";

export const ActiveQueueTableRow = props => {

    const { entry, idx } = props;
    const { sms_user_name, created_at } = entry;

    return (
        <tr>
            <td>
                <small>
                    {idx + 1}
                </small>
            </td>
            <td className="align-middle">
                <small>
                    {sms_user_name || '-'}
                </small>
            </td>
            <td className="align-middle">
                <small className="align-middle">
                    <FormattedDate value={created_at}/>
                    &nbsp;
                    <FormattedTime value={created_at}/>
                </small>
            </td>
        </tr>
    );

};